import { Flex, Text } from "@/atoms"
import { NO_VALUE_PLACEHOLDER } from "@/const/default-values"
import { useTranslation } from "@/hooks/useTranslation"
import { InformationPopover } from "@/molecules/InformationPopover"

import type { AiRelatedInsightContentProps } from "."

export const AiRelatedInsightContent = (
  props: AiRelatedInsightContentProps
) => {
  const { children, aiRelated, aiPackageCategory } = props
  const { t } = useTranslation("translation", {
    keyPrefix: "aiRelated.categories"
  })

  if (!aiRelated) return NO_VALUE_PLACEHOLDER

  return (
    <Flex gap={4} align="center">
      {children}
      {aiPackageCategory && (
        <Flex gap={4} align="center">
          <span>{aiPackageCategory}</span>
          <InformationPopover.Popover
            placement="top"
            content={
              <InformationPopover.CommonTemplate>
                <Flex vertical>
                  <Flex gap={3} align="center">
                    <Text strong>{t(`${aiPackageCategory}.title`)}</Text>
                    <Text type="secondary" className="sm-text-ks">
                      ({t("packageCategory")})
                    </Text>
                  </Flex>
                  <Text>{t(`${aiPackageCategory}.content`)}</Text>
                </Flex>
              </InformationPopover.CommonTemplate>
            }
          />
        </Flex>
      )}
    </Flex>
  )
}
